import React from 'react';
import { Dropdown, Button, Typography } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { formatDate } from '../../utils/dateUtils';
import { mapReferralStatus, conditionalStatusStyle } from '../../../services/utils';

const { Text } = Typography;

const CandidateApplicationsTable = ({ applications, referral }) => {
  const history = useHistory();
  const company = useSelector((state) => state.user.currentUser.company);


  const StatusPill = ({ status }) => {
    if (!status || status === '-') {
      return <Text type="secondary" style={{ fontSize: '12px' }}>—</Text>;
    }

    const mappedStatus = mapReferralStatus(status, company);

    const normalizedStatus = status
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/nothired/g, 'notHired')
      .replace(/noresponse/g, 'noResponse')
      .replace(/needsreview/g, 'needsReview');

    const statusStyle = conditionalStatusStyle(normalizedStatus);

    const colorMap = {
      'var(--tan-hide)': '#d4a373',
      'var(--old-mandarin)': '#ff6b35',
      'var(--fern)': '#228b22',
      'var(--forest-green)': '#228b22',
      'var(--oslo-gray)': '#595959',
      'var(--sunset-orange)': '#ff6347',
      'var(--royal-blue)': '#4169e1',
      'var(--mellow-yellow)': '#ffdb58',
      'var(--deep-blush)': '#ff69b4'
    };

    const hexColor = colorMap[statusStyle.color] || '#4169e1';

    return (
      <span
        style={{
          display: 'inline-block',
          padding: '2px 6px',
          borderRadius: '4px',
          backgroundColor: `${hexColor}15`,
          color: statusStyle.color,
          fontWeight: statusStyle.fontWeight,
          fontSize: '11px',
          border: `1px solid ${hexColor}30`
        }}
      >
        {mappedStatus}
      </span>
    );
  };

  const ApplicationRow = ({ app }) => {
    const items = [
      {
        key: 'view',
        label: 'View Referral',
        onClick: () => history.push(`/referrals/${app.legacyReferralId}`)
      }
    ];

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px 16px',
          paddingLeft: '32px',
          backgroundColor: '#fff',
          border: '1px solid #f0f0f0',
          borderTop: 'none',
          fontSize: '13px'
        }}
      >
        <div style={{ flex: 2, minWidth: 0, padding: '0 8px', display: 'flex', alignItems: 'center', minHeight: '100%' }}>
          {app.job?.id ? (
            <a
              href={`/jobs/${app.job.id}`}
              onClick={(e) => {
                e.preventDefault();
                history.push(`/jobs/${app.job.id}`);
              }}
              style={{
                color: '#1890ff',
                textDecoration: 'none',
                fontSize: '13px'
              }}
              onMouseEnter={(e) => {
                e.target.style.textDecoration = 'underline';
              }}
              onMouseLeave={(e) => {
                e.target.style.textDecoration = 'none';
              }}
            >
              {app.job.title}
            </a>
          ) : (
            <Text style={{ fontSize: '13px' }}>
              {app.job?.title || 'Unknown Position'}
            </Text>
          )}
        </div>

        <div style={{ flex: 1, textAlign: 'center', padding: '0 8px', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100%' }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {formatDate(app.atsApplicationDate)}
          </Text>
        </div>

        <div style={{ flex: 1, textAlign: 'center', padding: '0 8px', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100%' }}>
          <StatusPill status={app.applicationStatus} />
        </div>

        <div style={{ flex: 1, textAlign: 'center', padding: '0 8px', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100%' }}>
          <StatusPill status={app.applicationStage} />
        </div>


        <div style={{ width: '40px', textAlign: 'center' }}>
          <Dropdown
            menu={{ items }}
            trigger={['click']}
            placement="bottomRight"
          >
            <Button
              type="text"
              size="small"
              icon={<MoreOutlined />}
              style={{
                padding: '2px 4px',
                fontSize: '12px'
              }}
            />
          </Dropdown>
        </div>
      </div>
    );
  };

  if (!applications || applications.length === 0) {
    return null;
  }

  const sortedApplications = [...applications].sort((a, b) => {
    const dateA = new Date(a.referralDate);
    const dateB = new Date(b.referralDate);
    return dateB - dateA;
  });

  return (
    <div style={{ borderRadius: '0 0 16px 16px', overflow: 'hidden', border: '1px solid #f0f0f0', borderTop: 'none' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px 16px',
          paddingLeft: '32px',
          backgroundColor: '#fafafa',
          borderBottom: '1px solid #f0f0f0',
          fontSize: '12px',
          fontWeight: '500',
          color: '#595959'
        }}
      >
        <div style={{ flex: 2, padding: '0 8px' }}>Job Title</div>
        <div style={{ flex: 1, textAlign: 'center', padding: '0 8px' }}>Date</div>
        <div style={{ flex: 1, textAlign: 'center', padding: '0 8px' }}>Status</div>
        <div style={{ flex: 1, textAlign: 'center', padding: '0 8px' }}>Stage</div>
        <div style={{ width: '40px', textAlign: 'center' }}></div>
      </div>

      <div>
        {sortedApplications.map((app) => (
          <ApplicationRow key={app.id} app={app} />
        ))}
      </div>
    </div>
  );
};

export default CandidateApplicationsTable;